import React from "react"
import { observer } from "mobx-react-lite"

import Table from "@components/ui/BaseTable/Table"
import { SUBSCRIPTION_OPTIONS_KEYS } from "@framework/constants/subscription"
import { useStore } from "@store"

import ConnectorOptions from "./ConnectorOptions"

const Connectors: React.FC = observer(() => {
  const { subscriptionStore } = useStore()

  return (
    <Table hideBorder>
      <ConnectorOptions
        optionName={SUBSCRIPTION_OPTIONS_KEYS.CONNECTORS_BASIC}
        selectedConnectorOptions={subscriptionStore.data?.connectorsBasic}
      />
      <ConnectorOptions
        optionName={SUBSCRIPTION_OPTIONS_KEYS.CONNECTORS_PREMIUM}
        showTopBorder
        selectedConnectorOptions={subscriptionStore.data?.connectorsPremium}
      />
      <ConnectorOptions
        optionName={SUBSCRIPTION_OPTIONS_KEYS.CONNECTORS_CUSTOM}
        showTopBorder
        selectedConnectorOptions={subscriptionStore.data?.connectorsCustom}
      />
    </Table>
  )
})
export default Connectors
